module.exports = __webpack_public_path__ + "img/ELearningTitleJunior.1b98c050.png";